export default {
  appVersion: '01/10/2024',
  app: {
    logo: '',
    profileLogo: '',
    background: ''
  },
  lastestVersion: true
}